
<div class="wrapper">
    <div class="sidebar cust-sidebar-style" data-color="brown" data-active-color="danger">
        <sidebar-cmp></sidebar-cmp>
    </div>
    <div class="main-panel" (scroll)="onScroll($event)">
        <navbar-cmp></navbar-cmp>
        <router-outlet (activate)='onActivateRoute($event)'></router-outlet>
        <div *ngIf="!isMap()">
            <footer-cmp></footer-cmp>
        </div>
    </div>

</div>
<fixedplugin-cmp></fixedplugin-cmp>
